import clsx from "clsx";
import styled from "styled-components";

import * as Bulma from "~/types/bulma";

export type BarProps = Bulma.Common & Bulma.Expandable;

export const Bar = styled.progress.attrs<BarProps>((props) => ({
  className: clsx({
    ["progress"]: true,
    [`is-${props.kind}`]: Boolean(props.kind),
    [`is-${props.sized}`]: Boolean(props.sized),
  }),
}))<BarProps>`
  width: ${(props) => (props.fullwidth ? "100%" : "10em")};
`;

Bar.defaultProps = {
  max: "100",
};
